import React from 'react'
import { useInsiderCampaignLoader } from 'src/hooks/useInsiderCampaignLoader'
import useWindowDimensions from 'src/hooks/useWindowDimensions'
import InsiderShelfCampaign from '../InsiderShelf/InsiderShelfCampaign/InsiderShelfCampaign'
import InsiderShelfDefault from '../InsiderShelf/InsiderShelfDefault/InsiderShelfDefault'

interface Props {
  campaignId?: string
  campaignIdForMobile?: string
  campaignIdForTablet?: string
  defaultCollectionId: string
  title: string
  headingTitle?: HeadingLevel
  fontFamily?: string
}
const InsiderShelfRelatedProductsByNavigation: React.FC<Props> = ({
  campaignId,
  campaignIdForMobile,
  campaignIdForTablet,
  defaultCollectionId,
  title,
  headingTitle = 'h2',
  fontFamily = '1',
}) => {
  const { isMobile, isWindowBiggerThanTablet } = useWindowDimensions()
  const isTablet = !isMobile && !isWindowBiggerThanTablet
  const isDesktop = !isMobile && isWindowBiggerThanTablet

  const rawCampaignId =
    (isMobile && campaignIdForMobile) ||
    (isTablet && campaignIdForTablet) ||
    (isDesktop && campaignId) ||
    undefined

 const {
  isLoading,
  hasProducts,
} = useInsiderCampaignLoader(rawCampaignId, 5000)

  if (isLoading) {
    return null
  }

  return hasProducts && rawCampaignId ? (
    <InsiderShelfCampaign
      campaignId={Number(rawCampaignId)}
      insiderShelfTitle={title}
      headingTitle={headingTitle}
      fontfamily={fontFamily}
    />
  ) : (
    <InsiderShelfDefault
      collectionId={defaultCollectionId}
      insiderShelfTitle={title}
      headingTitle={headingTitle}
      fontfamily={fontFamily}
    />
  )
}

export default InsiderShelfRelatedProductsByNavigation
